/**
 * Parse an HTML string and return a DocumentFragment containing
 * only allowlisted elements and attributes.
 *
 * Keeps: <strong>, <em>, <b>, <i>, <br>, <a>, <p>
 * On <a>: only href (http, https, mailto, or root-relative) and rel
 * Everything else is flattened to its text content.
 *
 * @param {string} html
 * @returns {DocumentFragment}
 */
function sanitizeErrorHtml(html) {
	const allowedTags = new Set(['strong', 'em', 'b', 'i', 'br', 'a', 'p']);
	const safeUrlPattern = /^(https?:|mailto:|\/[^/])/i;

	const template = document.createElement('template');
	template.innerHTML = html;

	const walk = (parent) => {
		for (const child of [...parent.childNodes]) {
			if (child.nodeType === Node.TEXT_NODE) {
				continue;
			}

			if (child.nodeType !== Node.ELEMENT_NODE) {
				child.remove();
				continue;
			}

			if (!allowedTags.has(child.tagName.toLowerCase())) {
				child.replaceWith(document.createTextNode(child.textContent));
				continue;
			}

			// Strip all attributes except href and rel on anchors.
			for (const attr of [...child.attributes]) {
				const isAnchor = child.tagName === 'A';

				if (isAnchor && attr.name === 'href' && safeUrlPattern.test(attr.value)) {
					continue;
				}

				if (isAnchor && attr.name === 'rel') {
					continue;
				}

				child.removeAttribute(attr.name);
			}

			walk(child);
		}
	};

	walk(template.content);

	return template.content;
}

export { sanitizeErrorHtml };
